
import MainLayout from "@/components/layout/MainLayout";
import { DynamicDashboard } from "@/components/dashboard/DynamicDashboard";

const DynamicDashboards = () => {
  return (
    <MainLayout>
      <div className="space-y-6">
        <DynamicDashboard />
      </div>
    </MainLayout>
  );
};

export default DynamicDashboards;
